var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"map"}},[_c('div',{staticClass:"esri-widget",attrs:{"id":"info"}},[_c('auth')],1),_c('div',{staticClass:"esri-widget",attrs:{"id":"addData"}},[_c('AssetDataButton')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }